import authSagas from './auth';
import userManagementSaga from './userManagement';
import settingsSagas from './settings';
import customerSagas from './customer';
import ticketOutSaga from './ticketOut';
import alertsSaga from './alerts';
import accountSagas from './account';
import loanSagas from './loan';
import auditSagas from './audit';
import employeeSessionV2Sagas from './employeeSessionV2';
import onboardingSagas from './onboarding';

const sagas = [
  customerSagas,
  authSagas,
  userManagementSaga,
  settingsSagas,
  ticketOutSaga,
  alertsSaga,
  accountSagas,
  loanSagas,
  auditSagas,
  employeeSessionV2Sagas,
  onboardingSagas,
];

const registerSagas = (middleware) => {
  sagas.forEach((saga) => {
    middleware.run(saga);
  });
};

export default registerSagas;
